import apiFetch from '../apiFetch'

export default function (verracosAnadidos, token) {
  return apiFetch({endPoint: `GrupoVerraco/getVerracoGrupoVerracoList`, method: 'POST', body: verracosAnadidos, token: token})
}